export default __webpack_public_path__ + "static/media/liquidate_ticket.144fe9d9.png";